@let img = data();

<picture
  [paiPicture]="img.image"
  [mode]="img.imageOptions?.objectFit"
  [ratio]="img.imageOptions?.ratio"
  sizeSm="100vw"
  [size]="parentLayout().maxWidthAtMd"
  [sizeLg]="parentLayout().maxWidthAtLg"
  [sizeXl]="parentLayout().maxWidthAtXl"
></picture>
@if (img.caption) {
  <p>{{ img.caption }}</p>
}
